import React, { Component } from 'react'
import propTypes from 'prop-types'
import { inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'

import Action from '@components/Action'
import Add from '@components/Icon/Add'
import Delete from '@components/Icon/Delete'
import Edit from '@components/Icon/Edit'
import { showDialog, isCancellationError } from '@components/Dialog'

class Actions extends Component {
  static propTypes = {
    modalStore: propTypes.object,
    accountStore: propTypes.object,
    history: propTypes.object,
    account: propTypes.object,
    parentAccount: propTypes.object,
    invoicingEntities: propTypes.object,
    growlStore: propTypes.object
  }

  deleteAccount = accountId => {
    const { account, accountStore, history, growlStore } = this.props
    const { companyName } = account
    return showDialog({
      title: 'Delete this account?',
      text: companyName,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(() => {
        return accountStore.deleteAccount(accountId).then(() => {
          history.push('/client-search')
        })
      })
      .catch(err => {
        if (isCancellationError(err)) return
        growlStore.showError(err, `Couldn't delete account ${companyName}`)
      })
  }

  render () {
    const {
      accountStore,
      modalStore,
      account,
      parentAccount,
      invoicingEntities
    } = this.props

    return (
      <div className='actions-wrapper'>
        <ul className='actions'>
          <li
            className='action'
            data-cy='create-office-btn'
            onClick={e => {
              return modalStore.show({
                type: 'OFFICE_FORM',
                props: {
                  account,
                  parentAccount,
                  onSaveSuccess: createdOffice => {
                    this.props.history.push('/office/' + createdOffice.id)
                    this.props.modalStore.close()
                  }
                }
              })
            }}
          >
            <Action>
              <Add />
              <span>Create office</span>
            </Action>
          </li>
          <li
            className='action'
            data-cy='edit-account-btn'
            onClick={e => {
              return modalStore.show({
                type: 'ACCOUNT_FORM',
                props: {
                  account,
                  invoicingEntities,
                  parentAccount,
                  onSaveSuccess: account => {
                    accountStore.load(account.id)
                    modalStore.close()
                  }
                }
              })
            }}
          >
            <Action>
              <Edit />
              <span>Edit</span>
            </Action>
          </li>
          <li className='action'>
            <Action onClick={() => this.deleteAccount(account.id)}>
              <Delete />
              <span>Delete</span>
            </Action>
          </li>
        </ul>
      </div>
    )
  }
}

export default withRouter(inject('modalStore', 'growlStore')(Actions))
